export const planningDay = 86_400_000

export function parsePlanningDate(value: unknown): number | null {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null
    const result = Date.parse(`${value}T00:00:00Z`)
    return Number.isFinite(result) && formatPlanningDate(result) === value ? result : null
}

export const formatPlanningDate = (value: number) => new Date(value).toISOString().slice(0, 10)

/** Rolling anniversary, clamping 29 February to the last day of February. */
export function planningYearEnd(start: number): number | null {
    const date = new Date(start)
    const year = date.getUTCFullYear()
    if (!Number.isFinite(start) || year >= 9999) return null
    const day = date.getUTCDate()
    date.setUTCFullYear(year + 1, date.getUTCMonth() + 1, 0)
    date.setUTCDate(Math.min(day, date.getUTCDate()))
    return date.getTime()
}

/** 365 is the existing Year selector value, not a fixed day count. */
export function planningWindowEnd(from: string, horizon: number): string {
    const start = parsePlanningDate(from)
    if (start === null || ![91, 365].includes(horizon)) return ''
    const end = horizon === 365 ? planningYearEnd(start) : start + horizon * planningDay
    return end === null ? '' : formatPlanningDate(end)
}
